import * as React from 'react'

import { Redirect, Route, Switch } from 'react-router'

import { ProtectedRoute } from '@webapp/app'
import { useAppRoutes } from '@webapp/hooks'
import { ExpenseStatusPage } from './ExpenseStatusPage'
import { useModuleConfig } from '../module/useModuleConfig'

export const ExpenseRouter = () => {
  const { brp, url } = useAppRoutes()

  const { showExpenseRoutes } = useModuleConfig()

  if (!showExpenseRoutes) return <Redirect to={url('DashboardPage')} />

  return (
    <Switch>
      <ProtectedRoute
        path={brp('ExpenseStatusPage', { status: ':status' })}
        component={ExpenseStatusPage}
      />
      <Route
        path='*'
        render={() => (
          <Redirect to={url('ExpenseStatusPage', { status: 'pending' })} />
        )}
      />
    </Switch>
  )
}
